module.exports = __webpack_public_path__ + "static/media/camera.f3c22229.svg";